import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '../../Utility/Grid';

export default class BlankSlide extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  static defaultProps = {
    children: null
  };

  render() {
    const { children } = this.props;
    return <Grid.Container nogutter>{children}</Grid.Container>;
  }
}
